import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space["space-4"]};
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const ScratchedContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space["space-3"]};
`;

export const WinningTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space["space-3"]};
`;
